import React from 'react';

import Button from '../../../components/ui/Button';

const PreviewControls = ({ 
  currentSection, 
  onSectionChange, 
  onRefresh, 
  onClose,
  artistData 
}) => {
  const sections = [
    { id: 'home', name: 'Home', icon: 'Home' },
    { id: 'about', name: 'About', icon: 'User' },
    { id: 'calendar', name: 'Calendar', icon: 'Calendar' },
    { id: 'work', name: 'Work', icon: 'Briefcase' },
    { id: 'shop', name: 'Shop', icon: 'ShoppingBag' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900">Preview Controls</h3>
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          iconName="X"
        />
      </div>
      {/* Section Navigation */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-3">Navigate Sections</h4>
        <div className="grid grid-cols-2 gap-2">
          {sections?.map((section) => (
            <Button
              key={section?.id}
              variant={currentSection === section?.id ? "default" : "outline"}
              size="sm"
              onClick={() => onSectionChange(section?.id)}
              iconName={section?.icon}
              iconPosition="left"
              iconSize={16}
              className="justify-start"
            >
              {section?.name}
            </Button>
          ))}
        </div>
      </div>
      {/* Quick Actions */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-3">Quick Actions</h4>
        <div className="space-y-2">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            onClick={onRefresh}
            iconName="RefreshCw"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
          >
            Refresh Preview
          </Button>
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Download"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
          >
            Export Preview
          </Button>
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Share"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
          >
            Share Preview
          </Button>
        </div>
      </div>
      {/* Artist Info */}
      <div className="border-t border-gray-200 pt-4">
        <h4 className="text-sm font-medium text-gray-700 mb-3">Artist Information</h4>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Name:</span>
            <span className="text-gray-900 font-medium">{artistData?.profile?.name || "Artist Name"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Type:</span>
            <span className="text-gray-900">{artistData?.profile?.artistType || "Artist"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Status:</span>
            <span className="text-green-600 font-medium">Active</span>
          </div>
        </div>
      </div>
      {/* Technical Info */}
      <div className="border-t border-gray-200 pt-4">
        <h4 className="text-sm font-medium text-gray-700 mb-3">Technical Details</h4>
        <div className="space-y-2 text-xs text-gray-600">
          <div className="flex justify-between">
            <span>Screen Size:</span>
            <span>375 × 812px</span>
          </div>
          <div className="flex justify-between">
            <span>Device:</span>
            <span>iPhone 13 Pro</span>
          </div>
          <div className="flex justify-between">
            <span>Last Updated:</span>
            <span>{new Date()?.toLocaleDateString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewControls;